import { FC } from 'react';

import { Icon } from '@components/index';
import { acceptedLeadAdditionFileFormats } from '@features/lead-management/constants/leadBulkCreate';
import useDragAndDrop from '@hooks/useDragAndDrop';

interface LeadUploadFileSectionProps {
  file?: File;
  isLoading: boolean;
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checkFileValidityAndProcess: (selectedFile: File) => void;
}

const LeadUploadFileSection: FC<LeadUploadFileSectionProps> = ({
  file,
  isLoading,
  onFileSelect,
  checkFileValidityAndProcess
}) => {
  const { dragOver, setDragOver, onDragOver, onDragLeave, fileDropError } =
    useDragAndDrop();

  const onDrop = async (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(false);

    const selectedFile = e?.dataTransfer?.files[0];
    checkFileValidityAndProcess(selectedFile);
  };

  const renderTitle = () => {
    if (!file) {
      return (
        <>
          <Icon name="upload" size="none" className="size-9" />
          <div
            className={`mt-4 text-sm font-bold ${
              !file ? 'text-grey' : 'text-black'
            }`}
          >
            Drag and drop file here or{' '}
            <label
              htmlFor="file-input"
              className="cursor-pointer text-primary underline"
            >
              Upload a CSV or Excel File
            </label>
          </div>
          <div className="mt-3 text-sm font-normal text-grey">
            Supports .csv files, maximum no. of rows allowed would be 100
          </div>
        </>
      );
    }
    return null;
  };

  return (
    <div className="flex min-h-42 flex-col justify-center">
      {!file && !isLoading && (
        <input
          type="file"
          id="file-input"
          className="hidden"
          onChange={onFileSelect}
          accept={acceptedLeadAdditionFileFormats}
        />
      )}

      <div
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        className={`mt-3 flex flex-col items-center justify-center rounded-md border border-dashed border-grey ${
          dragOver ? 'bg-grey70' : ''
        } ${isLoading ? '!border-borderGrey5 bg-grey10' : ''}`}
      >
        {fileDropError && (
          <div className="w-full rounded-t-md bg-errorLite py-0.5 text-center text-xs text-error">
            {fileDropError}
          </div>
        )}
        <div
          className={`flex w-full flex-col items-center justify-center ${
            file || isLoading ? 'px-4 py-3' : 'px-6 py-8'
          }`}
        >
          {renderTitle()}
        </div>
      </div>
    </div>
  );
};
export default LeadUploadFileSection;
